import React, { useRef } from "react";
import { Typography, Box, Button, Grid, Chip } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Signature from "../../../../common/signature/signature";

// Define validation schema
const validationSchema = Yup.object().shape({
  agree: Yup.boolean().oneOf([true], "You must accept the terms to proceed."),
});

const AntiBullyingAdmission = () => {
  const staffSignatureRef = useRef(null);
  const cypSignatureRef = useRef(null);
  // Initial form values (this is necessary to avoid the error)
  const initialValues = {
    agree: true, // This must be initialized in Formik
  };

  return (
    <Formik
      initialValues={initialValues} // Initial values are required here
      validationSchema={validationSchema}
      onSubmit={(values) => {
        const signatureDataStaff = staffSignatureRef.current.getSignatureData();
        const signatureDataCYP = cypSignatureRef.current.getSignatureData();

        if (!signatureDataStaff || !signatureDataCYP) {
          alert("Please provide a signature");
          return;
        }

        const formData = { ...values, signatureDataStaff: signatureDataStaff, signatureDataCYP: signatureDataCYP }; // Include form values and signature

        console.log("Form data submitted:", formData);
      }}
    >
      {({ handleSubmit }) => (
        <Form onSubmit={handleSubmit} className='admission-form'>
          <Box className='header-section-mobile'>
            <Chip label='Admission' />
            <Typography sx={{ fontSize: "22px", fontWeight: "bold", color: "black" }} align='left' mt={1}>
              Anti-Bullying Contract
            </Typography>

            <Typography sx={{ fontSize: "14px" }} align='left'>
              A contract that outlines mutual respect and behavior expectations to prevent bullying among children,
              young people, and staff.
            </Typography>
          </Box>

          <Box className='content-section'>
            <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "black" }} align='left'>
              Anti-Bullying Contract (Review: April 2024 | Next Review: April 2025)
            </Typography>
            <Typography sx={{ fontSize: "14px", color: "black" }} mt={1}>
              Bullying will not be accepted at Little Norway, whether in the house, the surrounding gardens, or while
              out and about under any circumstances, from staff or young people. Bullying is a very serious matter, and
              nobody should have to endure it. There will be no verbal or physical abuse <br />
              towards anyone.
            </Typography>
            <Typography sx={{ fontSize: "14px", color: "black" }}>
              At Little Norway, we will be accepting of others regardless of their race, religion, cultural background,
              sexuality, or disability. There are consequences for any bullying incidents within the <br />
              home.
            </Typography>
            <Typography sx={{ fontSize: "14px", color: "black" }}>
              If you are being bullied, talk to a member of staff or contact Childline or Kidscape. These resources are
              very helpful and will offer you support and advice. You can do this in addition to using the complaints
              procedure at 443 (the forms are kept in the lounge, along with other useful telephone numbers). If you
              cannot find what you're looking for, please ask a member of the staff <br />
              team for assistance.
            </Typography>
            <Typography sx={{ fontSize: "14px", color: "black" }}>
              Please do not suffer in silence or allow anyone else to; speak out.
            </Typography>
          </Box>

          <Box className='agreement-section' display='flex' alignItems='center'>
            <ErrorIcon color='primary' />
            <Typography sx={{ fontSize: "14px", color: "black" }}>
              I have carefully read and understand the Anti-Bullying Contract and agree to follow the rules outlined.
            </Typography>
          </Box>

          <Box ml={2}>
            <Grid container spacing={5}>
              <Grid item xs={12} sm={5}>
                <Box className='signature-box'>
                  <Typography sx={{ fontSize: "14px" }}>Staff Name</Typography>
                  <Typography sx={{ fontWeight: "bold", fontSize: "14px", color: "black" }}>
                    Sudewa (line Manager)
                  </Typography>
                  <Signature ref={staffSignatureRef} />
                  <Typography align='right'>
                    <Grid container>
                      <Grid>
                        <Typography sx={{ fontSize: "14px", color: "#FFB700" }}>Venorox</Typography>
                      </Grid>
                      <Grid>
                        <Typography sx={{ fontSize: "14px" }}>/ Signature</Typography>
                      </Grid>
                    </Grid>
                    <Grid className='clear-signature-button'>
                      <Button variant='outlined' onClick={() => staffSignatureRef.current?.clearSignature()}>
                        Clear
                      </Button>
                    </Grid>
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} sm={7}>
                <Box className='signature-box'>
                  <Typography sx={{ fontSize: "14px" }} align='right' >
                    CYP Name
                  </Typography>
                  <Typography sx={{ fontWeight: "bold", fontSize: "14px", color: "black" }} align='right' >
                    Kolombouss
                  </Typography>
                  <Signature ref={cypSignatureRef} />
                  <Typography align='right'>
                    <Grid container>
                      <Grid>
                        <Typography sx={{ fontSize: "14px", color: "#FFB700" }}>Key Worker</Typography>
                      </Grid>
                      <Grid>
                        <Typography sx={{ fontSize: "14px" }}>/ Signature</Typography>
                      </Grid>
                    </Grid>
                    <Grid className='clear-signature-button'>
                      <Button variant='outlined' onClick={() => cypSignatureRef.current?.clearSignature()}>
                        Clear
                      </Button>
                    </Grid>
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Grid item xs={12}>
            <div className='submit-button-container'>
              <Button type='submit' variant='contained' color='primary' className='submit-button'>
                Submit
              </Button>
            </div>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default AntiBullyingAdmission;
